import { makeVar } from "@apollo/client";
const currentUser = makeVar({});
const selectedBrand = makeVar({});
export { currentUser, selectedBrand };
